import { render, staticRenderFns } from "./healthSafety.vue?vue&type=template&id=8c71d7dc&scoped=true&"
import script from "./healthSafety.vue?vue&type=script&lang=js&"
export * from "./healthSafety.vue?vue&type=script&lang=js&"
import style0 from "./healthSafety.vue?vue&type=style&index=0&id=8c71d7dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c71d7dc",
  null
  
)

export default component.exports